// export const API_URL = "http://localhost:8001";
// export const API_URL = "https://maximal-backend.onrender.com";
// export const API_URL =
//   "https://maximal-cloud-services-599144898107.us-central1.run.app";

 export const API_URL = "https://maximal-master-backend.onrender.com";